import { version } from 'vue';
const isV3 = version.startsWith('3.');
/**
 * @internal
 *
 * Adjust attributes to be usable in both Vue 2 and Vue 3 components.
 */
export function adaptVNodeAttrs(data) {
  return isV3 ? data : {
    attrs: data
  };
}